import React from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import styles from './ReviewConfirmation.module.scss'

// extraFeeType codes for the EV/Hybrid Levy, mapped to the banner copy key. Keyed on extraFeeType
// rather than vehicleFuelType/vehicleClass because the levy amount differs between standard and
// personalized plates for the same fuel type (confirmed against real RMV data, 2026-09-09):
//   EE  (electric, standard)     -> $500
//   EH  (plug-in hybrid, standard) -> $250
//   EEP (electric, personalized) -> $250
//   EHP (plug-in hybrid, personalized) -> $125
// vehicleFuelType alone can't distinguish EE from EEP (both fuel type "E"), so it can't select the
// right dollar amount for the banner copy - extraFeeType can, since RMV already encodes
// personalization into the type string itself. See CostCodeMap.java (IntegrationService).
const EV_LEVY_EXTRA_FEE_TYPES = {
  EE: 'electric',
  EH: 'plugInHybrid',
  EEP: 'electricPersonalized',
  EHP: 'plugInHybridPersonalized',
}

const EVLevyBanner = ({ t }) => {
  const permits = useSelector((state) => state.app.permits)

  const applicableTypeKeys = [
    ...new Set(
      permits
        .flatMap((permit) => permit.extraFees || [])
        .map((extraFee) => EV_LEVY_EXTRA_FEE_TYPES[extraFee.extraFeeType])
        .filter(Boolean)
    ),
  ]

  if (applicableTypeKeys.length === 0) {
    return null
  }

  return (
    <div className={styles['ev_levy_banner_container']}>
      {applicableTypeKeys.map((typeKey) => (
        <div className={styles['ev_levy_banner']} key={typeKey}>
          <div className={styles['ev_levy_banner_header']}>
            <i className={['fa fa-info-circle', styles['ev_levy_banner_icon']].join(' ')} aria-hidden="true" />
            <strong>{t('review_confirmation.ev_levy_banner_title')}</strong>
          </div>
          <ul className={styles['ev_levy_banner_list']}>
            <li>{t(`review_confirmation.ev_levy_banner_body_${typeKey}`)}</li>
            <li>
              {t('review_confirmation.ev_levy_banner_exemption')}{' '}
              {t('review_confirmation.ev_levy_learn_more_prefix')}
              <a href="http://novascotia.ca/EVHybridLevy" target="_blank" rel="noopener noreferrer">
                {t('review_confirmation.ev_levy_learn_more_link_text')}
                <span className="ns-visually-hidden">{t('shared.opens_new_tab')}</span>
              </a>
            </li>
          </ul>
        </div>
      ))}
    </div>
  )
}

export default withTranslation('common')(EVLevyBanner)
